/* v3 */
import klassifikation_v3 from '../thesaurus-v3/klassifikation';
import datierungen_v3 from '../thesaurus-v3/datierungen';
import material_v3 from '../thesaurus-v3/material';
import gefaesspartie_v3 from '../thesaurus-v3/gefaesspartie';
import vorgangsart_v3 from '../thesaurus-v3/vorgangsart';
import kategorie_v3 from '../thesaurus-v3/kategorie'
import probenarten_v3 from '../thesaurus-v3/probenarten';
import formPlanum_v3 from '../thesaurus-v3/form_planum';
import warenart_v3 from '../thesaurus-v3/warenart';
import formProfil_v3 from '../thesaurus-v3/form_profil';

/* v2 */
/*
import datierungen_v2 from '../thesaurus-v2/datierungen';
import gefaesspartie_v2 from '../thesaurus-v2/gefaesspartie';
import kategorie_v2 from '../thesaurus-v2/kategorie'
import klassifikation_v2 from '../thesaurus-v2/klassifikation';
import material_v2 from '../thesaurus-v2/material';
import probenarten_v2 from '../thesaurus-v2/probenarten';
import vorgangsart_v2 from '../thesaurus-v2/vorgangsart';
import warenart_v2 from '../thesaurus-v2/warenart';
*/

let rules = {

	// strings
	isString: {
		msgTitle : 'Freie Eingabe',
		msgText : '',
		testFor : 'isString',
		testFn : n => typeof n === 'string',
	},
	isJN: {
		msgTitle : 'Wahrheitswert ja / nein',
		msgText : '{j},{J},{ja},{Ja},{JA},{n},{N},{nein},{Nein},{NEIN}',
		testFor : 'isJN',
		testFn : n => {
			const validValues = [
				'j', 'J', 'ja',   'JA',   'Ja',
				'n', 'N', 'nein', 'NEIN', 'Nein',
			]
			
			return validValues.includes( n )
		}
	},
	isFreetext: {
		msgTitle : 'Freie Eingabe',
		msgText : '',
		testFor : 'isFreetext',
		testFn : n => true,
	},
	isFreetextNotEmpty: {
		msgTitle : 'Freitext erlaubt, darf nicht leer sein',
		msgText : '',
		testFor : 'isFreetextNotEmpty',
		testFn : n => {
			return ( n !== '' && n !== undefined ) ? true : false
		},
	},
	noNumSpecialChar: {
		msgTitle : '',
		msgText : '',
		testFor : 'noNumSpecialChar',
		testFn : n => {
			let re = /[\d#\+\$\%§]/;
			return !n.match(re);
		},
	},
	isEmpty: {
		msgTitle : '',
		msgText : '',
		testFor : 'isEmpty',
		testFn : n => n == '',
	},
	isGemarkung: {
		msgTitle : '',
		msgText : '',
		testFor : 'isGemarkung',
		testFn : n => {
			let re = /^\(?([a-z0-9]{1,4})\)?([/ ][a-z0-9]{1,})?$/;
			return n.match(re);
		},
	},
	
	// numbers
	isNum: {
		msgTitle : 'Ganzzahl',
		msgText : '{1} {25} {100025}',
		testFor : 'isNum',
		testFn : n => !isNaN(parseFloat(n)) && isFinite(n) && !n.includes('.') && !n.includes(',') ,
	},
	isNumOrEmpty: {
		msgTitle : 'Ganzzahl',
		msgText : '{1} {25} {100025}',
		testFor : 'isNum',
		testFn : n => {
			const isEmpty = (n === '') ? true : false
			const isValidNumber = !isNaN(parseFloat(n)) && isFinite(n) && !n.includes('.') && !n.includes(',')
			
			return (isEmpty || isValidNumber) ? true : false
		}	
	},
	isNumMany: {
		msgTitle : 'Zahlenkette mit Komma und Bindestrich erlaubt',
		msgText : '{1,3,4} {1,11-17,25}, {20}',
		testFor : 'isNumMany',
		testFn : n => {
			let validates = [];
			let str = n.replace(/\s/g, "").split(', ');
			str.forEach(function(s) {
			    validates.push(!isNaN(parseFloat(s)) && isFinite(s));
			});
			return (!validates.includes(false) || n == '' || n == undefined) ? true : false;
		},
	},
	isNumManyCommaSeparatedOrEmpty: { // wird nur für befundbeschreibung benutzt
		msgTitle : 'Nur Ganzzahlen, getrennt mit Komma, erlaubt',
		msgText : '{1,21,350}, {20}',
		testFor : 'isNumManyCommaSeparatedOrEmpty',
		testFn : (n, doLog = false)=>{
			let validates = [];
			let input     = n ? n.toString() : ''
			let parts     = input.split(',') 
			parts.forEach(function(s) {
				// eventuell doppeln sich hier tests, bzw. lässt sich das etwas eleganter lösen,
				// aber so funktionierts gut und der zusätzliche performancebedarf ist absolut 
				// vernachlässigbar
				validates.push(
					/^\d+$/.test(s) && 		 // allow only digits
					!isNaN(parseFloat(s)) && // must be number
					isFinite(s)              // must be finite 
				)
			})
			
			const hasOnlyValidNumbers = !validates.includes(false) ? true : false
			const isEmpty             = input === '' ? true : false
			const isValid             = hasOnlyValidNumbers || isEmpty ? true : false
			const debugIcon           = isValid ? '✅' : '❌'

			if( doLog ){
				console.groupCollapsed('isNumManyCommaSeparatedOrEmpty', debugIcon, '|'+n+'|')
				console.log('input:', input)
				console.log('parts:', parts)
				console.log('hasOnlyValidNumbers:', hasOnlyValidNumbers)
				console.log('isEmpty:', isEmpty)
				console.groupEnd()
			}
			
			return isValid
		}
	},
	isNumManywithDash: {
		msgTitle : 'Zahlenkette mit Komma und Bindestrich erlaubt',
		msgText : '{1,3,4} {1,11-17,25}, {20}',
		testFor : 'isNumManywithDash',
		testFn : n => {
			let validates = [];
			let str = n.replace(/,\s*$/, "").replace(/\s/g, "").split(/[,-]/);
			str.forEach(function(s) {
			    validates.push(!isNaN(parseFloat(s)) && isFinite(s));
			})
			
			const hasOnlyValidNumbers = !validates.includes(false) ? true   : false
			const hasNoPoints         = !n.includes('.') ? true             : false
			const isEmpty             = (n === '' || n == undefined) ? true : false
			
			/*			
			console.group('isNumManywithDash')
			console.log('n:', n)
			console.log('hasOnlyValidNumbers:', hasOnlyValidNumbers)
			console.log('hasNoPoints:', hasNoPoints)
			console.log('isEmpty:', isEmpty)
			console.groupEnd()
			*/
			
			return ( (hasOnlyValidNumbers && hasNoPoints) || isEmpty ) ? true : false			
			//return (!validates.includes(false) || n == '' || n == undefined) ? true : false;
		},
	},
	isNumManyWithoutDash: {
		msgTitle : 'Zahlenkette mit Komma erlaubt',
		msgText : '{1,3,4}, {20}',
		testFor : 'isNumManyWithoutDash',
		testFn : n => {
			let validates = [];
			let str = n.replace(/,\s*$/, "").replace(/\s/g, "").split(/[,-]/);
			str.forEach(function(s) {
				validates.push(!isNaN(parseFloat(s)) && isFinite(s));
			})
			
			const hasOnlyValidNumbers = !validates.includes(false) ? true   : false
			const hasNoPoints         = !n.includes('.') ? true             : false
			const hasNoDashs          = !n.includes('-') ? true             : false
			const isEmpty             = (n === '' || n == undefined) ? true : false
			
			/*
			console.group('isNumManyWithoutDash')
			console.log('n:', n)
			console.log('hasOnlyValidNumbers:', hasOnlyValidNumbers)
			console.log('hasNoPoints:', hasNoPoints)
			console.log('hasNoDashs:', hasNoDashs)
			console.log('isEmpty:', isEmpty)
			console.groupEnd()
			*/
			
			return ( (hasOnlyValidNumbers && hasNoPoints && hasNoDashs) || isEmpty ) ? true : false
		},
	},
	isNumTwoDec: {
		msgTitle : 'Zahl mit oder ohne Nachkommastelle',
		msgText : '{1}, {2.12}, {56.99}',
		testFor : 'isNumTwoDec',
		testFn : n => {
			//let re = /\d+[.]\d{2}/;
			const re = /^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/;			
			const isValidNumber = n.match( re ) ? true : false
			
			/*
			console.group('isNumTwoDec')
			console.log('n:', n)
			console.log('re:', re)
			console.log('isValidNumber:', isValidNumber)
			console.groupEnd()
			*/
			
			return isValidNumber
			//return n.match(re)
		},
	},
	isNumTwoDecOrEmpty: {
		msgTitle : 'Zahl mit oder ohne Nachkommastelle',
		msgText : '{1}, {2.12}, {56.99}',
		testFor : 'isNumTwoDecOrEmpty',
		testFn : n => {
			//let re = /\d+[.]\d{2}/;
			const isEmpty = (n === '') ? true : false
			const re = /^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/;			
			const isValidNumber = n.match( re ) ? true : false
			
			/*
			console.group('isNumTwoDecOrEmpty')
			console.log('n:', n)
			console.log('re:', re)
			console.log('isEmpty:', isEmpty)
			console.log('isValidNumber:', isValidNumber)
			console.groupEnd()
			*/
			
			return (isEmpty || isValidNumber) ? true : false
			//return n.match(re)
		},
	},
	isNumFour: {
		msgTitle : '',
		msgText : '',
		testFor : 'isNumFour',
		testFn : n => {
			let re = /\d{4}/;
			return n.match(re);
		},
	},
	isNumEndless: {
		msgTitle : 'Ganzzahl',
		msgText : '{1} {25} {100025}',
		testFor : 'isNumEndless',
		testFn : n => {
			let re = /\d+([.]\d+)?/;
			return n.match(re);
		},
	},
	hasNoNumbers: {
		msgTitle : '',
		msgText : '',
		testFor : 'hasNoNumbers',
		testFn : n => {
			let re = /\d/;
			return !n.match(re);
		},
	},

	// date
	isDate: {
		msgTitle : 'Datum',
		msgText : '{24.12.2020}',
		testFor : 'isDate',
		testFn : n => {
			const re          = /\d{2}(\.)\d{2}(\.)\d{4}/
			const isValidDate = n.match( re ) ? true : false
			
			return isValidDate
			//return n.match(re) === null ? false : true;
		},
	},

	// thesauri v3
	classificationThes: {
		msgTitle : 'Werte aus dem Klassifikations-Thesauri',
		msgText : '',
		testFor : 'classificationThes',
		testFn : n => klassifikation_v3.includes(n),
	},
	formPlanumThes: {
		msgTitle : 'Werte aus der Form-Planum-Thesauri',
		msgText : '',
		testFor : 'formPlanumThes',
		testFn : n => formPlanum_v3.includes(n),
	},
	formProfilThes: {
		msgTitle : 'Werte aus der Form-Profil-Thesauri',
		msgText : '',
		testFor : 'formProfilThes',
		testFn : n => formProfil_v3.includes(n),
	},
	DateThes: {
		msgTitle : 'Werte aus Datums-Thesauri',
		msgText : '',
		testFor : 'DateThes',
		testFn : n => datierungen_v3.includes(n),
	},
	MaterialThes: {
		msgTitle : 'Werte aus Material-Thesuri',
		msgText : '',
		testFor : 'MaterialThes',
		testFn : n => material_v3.includes(n),
	},
	VorgangsThes: {
		msgTitle : 'Werte aus Vorgangs-Thesauri',
		msgText : '',
		testFor : 'VorgangsThes',
		testFn : n => vorgangsart_v3.includes(n),
	},
	CategoryThes: {
		msgTitle : 'Werte aus dem Kategorie-Thesauri',
		msgText : '',
		testFor : 'CategoryThes',
		testFn : n => kategorie_v3.includes(n),
	},
	ProbenThes: {
		msgTitle : 'Werte aus dem Proben-Thesauri',
		msgText : '',
		testFor : 'ProbenThes',
		testFn : n => probenarten_v3.includes(n),
	},
	FormProfilThes: {
		msgTitle : 'Werte aus dem Form-Profil-Thesauri',
		msgText : '',
		testFor : 'FormProfilThes',
		testFn : n => formProfil_v3.includes(n),
	},
	PartiThes: {
		msgTitle : 'Werte aus Parti-Thesauri',
		msgText : '',
		testFor : 'PartiThes',
		testFn : function(n) {
			let validates = [];
			let str = n.split(', ');
			str.forEach(function(s) {
				//let substr = s.split(" ");
			    //validates.push(rules.isNum.testFn(substr[0]) ? validates : false);
				//validates.push(gefaesspartie_v3.includes(substr[1]) ? validates : false);
				validates.push( gefaesspartie_v3.includes(s) ? validates : false );
			});
			return validates.includes(false)? false : true;
		},
	},
	warenartThes: {
		msgTitle : 'Werte aus Warenart-Thesauri',
		msgText : '',
		testFor : 'warenartThes',
		testFn : function(n) {
			//console.log('n:', n)
			let validates = [];
			let str = n.split(', ');
			str.forEach(function(s) {
				// 2020-09-02 nachstehende funktion war von toni drin
				// allerdings steht in warenart.js explizit "handgemachte Ware",
				// diese value würde damit ja niemals erreicht werden.
				// deshalb habe ich die replace-fn deaktiviert
				//s = s.replace(' ','_');
				validates.push( warenart_v3.includes(s) ? validates : false );
			});
			const isValid = validates.includes( false ) ? false : true;
			
			return isValid
		},
	},
  	
	// thesauri v2
	/*
  	classificationThes_v2: {
		msgTitle : 'Werte aus dem Klassifikations-Thesauri',
		msgText : '',
		testFor : 'classificationThes_v2',
		testFn : n => klassifikation_v2.includes(n),
	},
	//formPlanumThes_v2: n => formPlanum_v2.includes(n), // TODO: Klären warum diese Zeile enthalten war
	DateThes_v2: {
		msgTitle : 'Werte aus Datums-Thesauri',
		msgText : '',
		testFor : 'DateThes_v2',
		testFn : n => datierungen_v2.includes(n),
	},
	MaterialThes_v2: {
		msgTitle : 'Werte aus Material-Thesuri',
		msgText : '',
		testFor : 'MaterialThes_v2',
		testFn : n => material_v2.includes(n),
	},
	VorgangsThes_v2: {
		msgTitle : 'Werte aus dem Vorgangs-Thesauri',
		msgText : '',
		testFor : 'VorgangsThes_v2',
		testFn : n => vorgangsart_v2.includes(n),
	},
	CategoryThes_v2: {
		msgTitle : 'Werte aus dem Kategorie-Thesauri',
		msgText : '',
		testFor : 'CategoryThes_v2',
		testFn : n => kategorie_v2.includes(n),
	},
	ProbenThes_v2: {
		msgTitle : 'Werte aus dem Probenarten-Thesauri',
		msgText : '',
		testFor : 'ProbenThes_v2',
		testFn : n => probenarten_v2.includes(n),
	},
	//FormProfilThes_v2: n => formProfil_v2.includes(n),  // TODO: Klären warum diese Zeile enthalten war
	PartiThes_v2: {
		msgTitle : 'Werte aus dem Parti-Thesauri',
		msgText : '',
		testFor : 'PartiThes_v2',
		testFn : function(n) {
			let validates = [];
			let str = n.split(', ');
			str.forEach(function(s) {
				//let substr = s.split(" ");
			    //validates.push(rules.isNum.testFn(substr[0]) ? validates : false);
				//validates.push(gefaesspartie_v2.includes(substr[1]) ? validates : false);
				validates.push( gefaesspartie_v2.includes(s) ? validates : false );

			});
			return validates.includes(false)? false : true;
		},
	},
	warenartThes_v2: {
		msgTitle : 'Werte aus dem Warenart-Thesauri',
		msgText : '',
		testFor : 'warenartThes_v2',
		testFn : function(n) {
			let validates = [];
			let str = n.split(', ');
			str.forEach(function(s) {
				s = s.replace(' ','_');
				validates.push(warenart_v2.includes(s) ? validates : false );
			});
			return validates.includes(false)? false : true;
		},
	},
	*/

}

export {rules};
